export default __webpack_public_path__ + "static/media/about2.83a65e3b.png";